export default {"src":"/_next/static/media/contract.4bd9cd09.svg","height":479,"width":560,"blurWidth":0,"blurHeight":0};